export const DEMO_AUTH_KEY = "msm_demo_auth";

export function startDemoSession({ role, name, email, remember = true }) {
  const session = {
    role,
    name: name?.trim() || "Pengguna",
    email: email?.trim() || "",
    signedInAt: new Date().toISOString(),
    mode: "demo",
  };

  try {
    const target = remember ? localStorage : sessionStorage;
    const other = remember ? sessionStorage : localStorage;
    target.setItem(DEMO_AUTH_KEY, JSON.stringify(session));
    other.removeItem(DEMO_AUTH_KEY);
  } catch {
    /* Navigation can continue when browser storage is unavailable. */
  }

  return session;
}

export function mergeLocalRecord(key, values) {
  try {
    const current = JSON.parse(localStorage.getItem(key));
    const next = { ...(current && typeof current === "object" ? current : {}), ...values };
    localStorage.setItem(key, JSON.stringify(next));
    return next;
  } catch {
    return values;
  }
}
